import React from "react";
import { ThemeProvider } from "styled-components";
import CountPlot from "../countplots/CountPlot";
import { Container, FlexCentered, Title } from "../styles/General.styled";
import GlobalStyles from "../styles/Global";
import theme from "../styles/theme";
import OverView from "./OverView";

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Container bgColor="#DADDFC" mh="100vh">
        <FlexCentered>
          <Title fs="3rem" m="1.5rem 0 0 0" ta="center">
            Analysis of various causes of death (NYC)
          </Title>
          <OverView />
          <CountPlot />
        </FlexCentered>
      </Container>
    </ThemeProvider>
  );
};

export default App;
